import { BackendApi } from "./backend-api";
import { HDMediaRequest } from "../helpers/interfaces";

export default class CameraMediaApi {
    private backendApi: BackendApi;

    constructor() {
        this.backendApi = BackendApi.Instance;
    }

    async getImage(cameraId: number, filename: string, args?: any) {
        return this.backendApi.getApiResponse({
            endPoint: `/media/${cameraId}/${filename}`,
            queryStringParams: args,
            priority: 'low'
        });
    }

    async getSingleMediaItemByFieldCombo(media_type: string, location_id: number, capture_datetime: string,  sequence_id: string) {
        return this.backendApi.getApiResponse({
            endPoint: `/media/get_single_media/${media_type}/location/${location_id}/datetime/${capture_datetime}/seq/${sequence_id}`,
        });
    }

    async requestHDImage(mediaId: number): Promise<HDMediaRequest> {
        return this.backendApi.getApiResponse({
            endPoint: `/media/${mediaId}/hd`,
            priority: 'high'
        });
    }

    async downloadMedia(caseId: number, media_ids: number[], filter_hd= false, include_hd_images_if_exists= false): Promise<Blob> {
        return this.backendApi.getApiResponse({
            endPoint: `/media/download`,
            method: "POST",
            data: {
                case_id: caseId,
                media_ids: media_ids,
                filter_hd: filter_hd,
                include_hd_images_if_exists: include_hd_images_if_exists
            }
        });
    }

    async markMediaAsLocked (mediaId: number) {
        return this.backendApi.getApiResponse({
            endPoint: `/media/mark-as-locked/${mediaId}`,
            method: "POST",
            data: {},
            priority: 'high'
        });
    }

    async markMediaListAsLocked(media_ids: number[]) {
        return this.backendApi.getApiResponse({
            endPoint: `/media/mark-media-list-as-locked/`,
            method: "POST",
            data: {media_id_list: media_ids},
            priority: 'high'
        });
    }

    async markMediaAsUnlocked (mediaId: number) {
        return this.backendApi.getApiResponse({
            endPoint: `/media/mark-as-unlocked/${mediaId}`,
            method: "POST",
            data: {},
            priority: 'high'
        });
    }

    async markMediaListAsUnlocked(media_ids: number[]) {
        return this.backendApi.getApiResponse({
            endPoint: `/media/mark-media-list-as-unlocked/`,
            method: "POST",
            data: {media_id_list: media_ids},
            priority: 'high'
        });
    }

    async getLockedMediaItems (locationId: number, captureDate: string) {
        return this.backendApi.getApiResponse({
            endPoint: `/media/get_locked_media_items/location/${locationId}/date/${captureDate}`,
            method: "GET"
        });
    }

    async deleteMedia(mediaId: number) {
        return this.backendApi.getApiResponse({
            endPoint: `/media/permanently_delete/${mediaId}`,
            method: "DELETE"
        });
    }

    async renameMedia(mediaId: number, newName: string) {
        return this.backendApi.getApiResponse({
            endPoint: `/media/rename/${mediaId}`,
            method: "PUT",
            data: { new_name: newName }
        });
    }

    //async getMediaIsLockedValue (mediaId: number) {
    //    return this.backendApi.getApiResponse({
    //        endPoint: `/media/mark-as-locked/${mediaId}`,
    //        method: "POST",
    //        data: {}
    //    });
    //}
}